"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnOneLinks = [{
  href: 'https://wwww.headspace.com/subscriptions',
  linkText: 'subscribe'
}, {
  href: 'https://wwww.headspace.com/code',
  linkText: 'redeem a code'
}, {
  href: 'https://wwww.headspace.com/buy/gift',
  linkText: 'send a gift'
}, {
  href: 'https://wwww.headspace.com/meditation/guided-meditation',
  linkText: 'guided meditation'
}, {
  href: 'https://wwww.headspace.com/meditation/work',
  linkText: 'meditation for work'
}, {
  href: 'https://wwww.headspace.com/meditation/kids',
  linkText: 'meditation for kids'
}, {
  href: 'https://wwww.headspace.com/meditation/sleep',
  linkText: 'meditation on sleep'
}, {
  href: 'https://wwww.headspace.com/meditation/focus',
  linkText: 'meditation on focus'
}, {
  href: 'https://wwww.headspace.com/meditation/stress',
  linkText: 'meditation on stress'
}, {
  href: 'https://wwww.headspace.com/meditation/anxiety',
  linkText: 'meditation on anxiety'
}];
exports.columnTwoLinks = [{
  href: 'https://wwww.headspace.com/about-us',
  linkText: 'about headspace'
}, {
  href: 'https://wwww.headspace.com/andy-puddicombe',
  linkText: 'about andy puddicombe'
}, {
  href: 'https://wwww.headspace.com/buy/headspace-meditation-books',
  linkText: "andy's books"
}, {
  href: 'https://wwww.headspace.com/meditation/press-and-media',
  linkText: 'press & media'
}, {
  href: 'https://wwww.headspace.com/meditation/join-us',
  linkText: 'careers'
}];
exports.badgeLinks = [{
  href: 'https://smart.link/592606113ab53?utm_source=headspace&utm_medium=app-badge&utm_campaign=hs-site-footer&site_id=headspace_website&creative_id=headspace_website-hs-site-footer-app-badge',
  src: 'https://www.headspace.com/images/app-store-9536c9c69b2142962b803da5de7c1864.png',
  linkText: undefined
}, {
  href: 'https://wwww.headspace.com/andy-puddicombe',
  src: 'https://www.headspace.com/images/google-play-e8e6ebaa17b8392d041c664fca2ae92b.png',
  linkText: undefined
}];